
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter, Action, Mutation } from "vuex-class";
import Loader from "@/components/App/Loader.vue";
import appConstants from "@/appConstants";
import _ from "lodash";
@Component({
  components: {
    Loader
  }
})
export default class ContactForm extends Vue {
  @Prop() private title!: string;
  @Prop() private memberContactType!: number;
  @Prop() private selected!: any;
  @Getter("memberContact") memberContact: any;
  @Getter("memberCompanyInfo") memberCompanyInfo: any;
  @Action("getUserList") getUserList: any;
  @Action("getUserCompanyInfo") getUserCompanyInfo: any;
   private isFirstNameInvalid = false;
  private isLastNameInvalid = false;
  private isEmailInvalid = false;

  loading = false;
  created() {
    this.getUserList();
    this.getUserCompanyInfo();
    this.firstname = "";
    console.log("---" + this.memberContactType);
  }

  set firstname(newValue: string) {
    switch (Number(this.memberContactType)) {
      case appConstants.memberContactTypes.Security:
        this.memberContact.security.firstName = newValue;
        break;
      case appConstants.memberContactTypes.Invoice:
        this.memberContact.invoice.firstName = newValue;
        break;
      case appConstants.memberContactTypes.Payment:
        this.memberContact.payment.firstName = newValue;
        break;
      case appConstants.memberContactTypes.Legal:
      this.memberContact.legal.firstName = newValue;
      break;
      case appConstants.memberContactTypes.Qualification:
      this.memberContact.qualification.firstName = newValue;
      break;
      default: {
        break;
      }
    }
  }

  get firstname() {
    let fname = "";
    switch (Number(this.memberContactType)) {
      case appConstants.memberContactTypes.Security:
        fname = this.memberContact.security.firstName;
        break;
      case appConstants.memberContactTypes.Invoice:
        fname = this.memberContact.invoice.firstName;
        break;
      case appConstants.memberContactTypes.Payment:
        fname = this.memberContact.payment.firstName;
        break;
      case appConstants.memberContactTypes.Legal:
        fname = this.memberContact.legal.firstName;
        break;
      case appConstants.memberContactTypes.Qualification:
        fname = this.memberContact.qualification.firstName;
        break;
      default: {
        fname = "";
        break;
      }      
    }
    return fname;
  }

  set lastname(newValue: string) {
    switch (Number(this.memberContactType)) {
      case appConstants.memberContactTypes.Security:
        this.memberContact.security.lastName = newValue;
        break;
      case appConstants.memberContactTypes.Invoice:
        this.memberContact.invoice.lastName = newValue;
        break;
      case appConstants.memberContactTypes.Payment:
        this.memberContact.payment.lastName = newValue;
        break;
      case appConstants.memberContactTypes.Legal:
        this.memberContact.legal.lastName = newValue;
        break;
      case appConstants.memberContactTypes.Qualification:
        this.memberContact.qualification.lastName = newValue;
        break;      
      default: {
        break;
      }
    }
  }

  get lastname() {
    let lname = "";
    switch (Number(this.memberContactType)) {
      case appConstants.memberContactTypes.Security:
        lname = this.memberContact.security.lastName;
        break;
      case appConstants.memberContactTypes.Invoice:
        lname = this.memberContact.invoice.lastName;
        break;
      case appConstants.memberContactTypes.Payment:
        lname = this.memberContact.payment.lastName;
        break;
      case appConstants.memberContactTypes.Legal:
        lname = this.memberContact.legal.lastName;
        break;
     case appConstants.memberContactTypes.Qualification:
        lname = this.memberContact.qualification.lastName;
        break;
      default: {
        lname = "";
        break;
      }
    }
    return lname;
  }

  set email(newValue: string) {
    switch (Number(this.memberContactType)) {
      case appConstants.memberContactTypes.Security:
        this.memberContact.security.email = newValue;
        break;
      case appConstants.memberContactTypes.Invoice:
        this.memberContact.invoice.email = newValue;
        break;
      case appConstants.memberContactTypes.Payment:
        this.memberContact.payment.email = newValue;
        break;
      case appConstants.memberContactTypes.Legal:
        this.memberContact.legal.email = newValue;
        break;
      case appConstants.memberContactTypes.Qualification:
        this.memberContact.qualification.email = newValue;
        break;
      default: {
        break;
      }   
    }
  }

  get email() {
    let emailaddress = "";
    switch (Number(this.memberContactType)) {
      case appConstants.memberContactTypes.Security:
        emailaddress = this.memberContact.security.email;
        break;
      case appConstants.memberContactTypes.Invoice:
        emailaddress = this.memberContact.invoice.email;
        break;
      case appConstants.memberContactTypes.Payment:
        emailaddress = this.memberContact.payment.email;
        break;
      case appConstants.memberContactTypes.Legal:
        emailaddress = this.memberContact.legal.email;
        break;
     case appConstants.memberContactTypes.Qualification:
        emailaddress = this.memberContact.qualification.email;
        break;
      default: {
        emailaddress = "";
        break;
      }
    }
    return emailaddress;
  }

  set release(newValue: boolean) {
    switch (Number(this.memberContactType)) {      
      case appConstants.memberContactTypes.Qualification:
        this.memberContact.qualification.release = newValue;
        break;
      default: {
        break;
      }   
    }
  }

  get release() {
    let releaseConsent = false;
    switch (Number(this.memberContactType)) {      
     case appConstants.memberContactTypes.Qualification:
        releaseConsent = this.memberContact.qualification.release;
        break;
      default: {
        //releaseConsent = true;
        break;
      }
    }
    return releaseConsent;
  }

  get users() {
    //return this.memberInfo.users || null;
    const userlist = [];
    for (const userobj of this.memberContact.users) {
      userlist.push({
        value: userobj.FirstName + " " + userobj.LastName,
        text: userobj.Email
      });
    }
    return userlist;
  }

  
  onSubmit() {
    console.log("kannan");
  }

  inputChanged() {
    console.log("inputChanged");
    return false;
  }
  keyp() {
    console.log("keyp");
  }

  isChanged() {
    console.log("isChanged");
  }

  cancelChanges() {
    this.$router.push({ path: "/membercontact" });
  }

  saveChanges() {
    if (this.checkFirstName() && this.checkLastName() && this.checkEmail() && this.validateEmail() ){
    this.loading = true;
    this.$store
      .dispatch("updateContact", {
        CrmMemberID: this.memberCompanyInfo.MemberTypeCrmID,
        SecurityContactFirstname: this.memberContact.security.firstName,
        SecurityContactLastname: this.memberContact.security.lastName,
        SecurityContactEmail: this.memberContact.security.email,
        InvoiceContactFirstname: this.memberContact.invoice.firstName,
        InvoiceContactLastname: this.memberContact.invoice.lastName,
        InvoiceContactEmail: this.memberContact.invoice.email,
        PaymentContactFirstname: this.memberContact.payment.firstName,
        PaymentContactLastname: this.memberContact.payment.lastName,
        PaymentContactEmail: this.memberContact.payment.email,
        LegalContactFirstname: this.memberContact.legal.firstName,
        LegalContactLastname: this.memberContact.legal.lastName,
        LegalContactEmail: this.memberContact.legal.email,
        QualificationContactFirstname: this.memberContact.qualification.firstName,
        QualificationContactLastname: this.memberContact.qualification.lastName,
        QualificationContactEmail: this.memberContact.qualification.email,
        ReleaseQualificationContact : this.memberContact.qualification.release
      })
      .then(() => {
        this.loading = false;
        this.$router.push({ path: "/membercontact" });
      });
    }
      if (!this.checkFirstName()){
       this.isFirstNameInvalid = true
     } 
     if (!this.checkLastName()){
       this.isLastNameInvalid = true
     } 
     if (!this.checkEmail() || !this.validateEmail()){
       this.isEmailInvalid = true
     }
    
  }
    // simple check that the form inputs have something in them
  // check first name input
  public checkFirstName() {
    if (this.firstname.replace(/\s/g, '').length > 1) {
      return true;
    }
  }

  
  // check last name input
  public checkLastName() {
    if (this.lastname.replace(/\s/g, '').length > 1) {
      return true;
    }
  }
  // check email input
  public checkEmail() {
    if (this.email.replace(/\s/g, '').length > 1) {
      return true;
    }
  }
  // simple check of email validity
  public validateEmail() {
    const re = /\S+@\S+\.\S+/;
    return re.test(this.email);
  }

  changeContact(event: any) {
    let contactType = "";

    switch (Number(this.memberContactType)) {
      case appConstants.memberContactTypes.Security: {
        contactType = "security";
        break;
      }
      case appConstants.memberContactTypes.Invoice: {
        contactType = "invoice";
        break;
      }
      case appConstants.memberContactTypes.Payment: {
        contactType = "payment";
        break;
      }
      case appConstants.memberContactTypes.Legal: {
        contactType = "legal";
        break;
      }
      case appConstants.memberContactTypes.Qualification: {
        contactType = "qualification";
        break;
      }
      default: {
        //statements;
        break;
      }
    }
    this.$store.dispatch("setContact", {
      contactType: contactType,
      contactInfo: {
        firstName: this.selected.split(",")[0].split(" ")[0],
        lastName: this.selected.split(",")[0].split(" ")[1],
        email: this.selected.split(",")[1]
      }
    });
  }
}
